export class UserGroup {

    id: string = '';
    name: string = '';
    status: string = '';
    createdAt: string = '';
    updatedAt: string = '';


    constructor(raw?: any) {
        if (raw) {
            this.id = raw.id;
            this.name = raw.name;
            this.status = raw.status
            this.createdAt = raw.createdAt
            this.updatedAt = raw.updatedAt;
        }
    }
}
